import { myFilesStateDict } from '@/modules/FileList/data/myFilesList/myFilesStateDict';
import { FILE_LIST_LINKS } from '@/modules/FileList/fileListLinks';
import {
  MyFilesListQueryKey,
  MyFilesListParamsType,
} from '@/modules/FileList/queries/myFilesList/myFilesListQuery.type';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

const useFilterQueryParams = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const convertedParams = () => {
    const params = searchParams.get(
      'fileListParams',
    ) as MyFilesListParamsType as string;
    try {
      return JSON.parse(params);
    } catch (e) {
      return {};
    }
  };

  const fileListParams: MyFilesListParamsType = convertedParams();

  const pageTitle = fileListParams?.state
    ? myFilesStateDict[fileListParams.state.value]
    : null;

  const resetQueryParams = () => {
    navigate(
      FILE_LIST_LINKS.resetFileListParams({
        location: location.pathname,
        state: fileListParams?.state,
      }),
      { replace: true },
    );
  };
  const SpliceArrayQueryParams = ({
    index,
  }: {
    removedItem: MyFilesListQueryKey;
    index: number;
  }) => {
    fileListParams['insurance']?.splice(index, 1);
    navigate(
      FILE_LIST_LINKS.addFilterParams({
        location: location.pathname,
        params: fileListParams,
      }),
      { replace: true },
    );
  };
  const filterQueryParams = ({
    removedItem,
  }: {
    removedItem: MyFilesListQueryKey;
  }) => {
    if (fileListParams) {
      if (removedItem === MyFilesListQueryKey.RANGE_DATE) {
        delete fileListParams[MyFilesListQueryKey.FORM_DATE];
        delete fileListParams[MyFilesListQueryKey.TO_DATE];
      } else {
        delete fileListParams[removedItem];
      }
    }
    navigate(
      FILE_LIST_LINKS.addFilterParams({
        location: location.pathname,
        params: fileListParams,
      }),
      { replace: true },
    );
  };

  const apiParams =
    fileListParams &&
    Object.fromEntries(
      Object.entries(fileListParams).map(([key, value]) => {
        if (typeof value === 'object' && value !== null && 'value' in value) {
          return [key, value.value];
        }
        return [key, value];
      }),
    );

  return {
    pageTitle,
    fileListParams,
    resetQueryParams,
    filterQueryParams,
    apiParams,
    SpliceArrayQueryParams,
  };
};

export default useFilterQueryParams;
